import { path } from './helpers'
import Vue from 'vue'

const api = Vue.prototype.$api
function accountPath (resource) {
  return path(`/webapp/${resource}`)
}

export default {
  updateReadTermsDate (token) {
    return api.post(accountPath('user-terms'), {}, {
			headers: {
				'Authorization': `Bearer ${token}`
			}
		})
  },
	updateReadPrivacyPolicyDate (token) {
		return api.post(accountPath('user-privacy-policies'), {}, {
			headers: {
				'Authorization': `Bearer ${token}`
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/repositories/WebappRepository.js